import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconGiftSvg } from "./IconGiftSvg.mjs";
const IconGift = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconGiftSvg, ...iconProps });
};
export {
  IconGift
};
